import { cn } from '@/lib/utils';
import { TRANSCRIPTION_SOURCES, type TranscriptionSource } from '@/lib/transcription-source';

type TranscriptionSourcePickerProps = {
  t: Record<string, unknown>;
  value: TranscriptionSource;
  onChange: (source: TranscriptionSource) => void;
};

/** Phrases, initial-data spoken answers, or both (backend spec 015). */
export function TranscriptionSourcePicker({ t, value, onChange }: TranscriptionSourcePickerProps) {
  const labels = (t.transcriptionSources ?? {}) as Partial<Record<TranscriptionSource, string>>;
  return (
    <div className="space-y-2">
      <p className="text-sm text-muted-foreground">{String(t.transcriptionSourceLabel ?? '')}</p>
      <div role="radiogroup" aria-label={String(t.transcriptionSourceLabel ?? '')} className="grid grid-cols-3 gap-1 rounded-xl border border-border/50 p-1">
        {TRANSCRIPTION_SOURCES.map((source) => (
          <button
            key={source}
            type="button"
            role="radio"
            aria-checked={value === source}
            onClick={() => onChange(source)}
            className={cn(
              'rounded-lg px-2 py-1.5 text-xs leading-tight transition-colors sm:text-sm',
              value === source ? 'bg-foreground text-background' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {labels[source] ?? source}
          </button>
        ))}
      </div>
    </div>
  );
}
